

//OLD FROM APRIL 12th
import axios from "axios";
import { API_URL } from "../../services/api";

let refresh = false;

axios.interceptors.response.use(
  (response) => response, 
  async (error) => {
    if (error.response.status === 401 && !refresh) {
      refresh = true;

      try {
        const response = await axios.post(
          `${API_URL}token/refresh/`,
          { refresh: localStorage.getItem('refresh_token') },
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true, 
          }
        );

        if (response.status === 200) {
          // Update access token in headers and local storage
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
          localStorage.setItem('access_token', response.data.access);
          localStorage.setItem('refresh_token', response.data.refresh);

          // Retry the original failed request
          return axios(error.config);
        }
      } catch (e) {
        // console.log('Token refresh failed. Logging out:', e);

        // Clear tokens from local storage
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        axios.defaults.headers.common['Authorization'] = null;

        // Redirect to login page
        window.location.href = '/login';
      }
    }

    refresh = false;
    return Promise.reject(error); 
  }
);


